import { useCallback, useEffect, useState } from 'react'
import { Icon, IconNames } from 'atoms/Icon'
import { InputCardBox, InputCreditCardSC } from './PopupComponents.styled'

export interface IInputNumberCreditCard {
  cardType?: string
  errorMessage?: string
  onChangeInput: (arg: string) => void
}

export const InputNumberCreditCard = ({
  errorMessage,
  cardType,
  onChangeInput,
}: IInputNumberCreditCard) => {
  const [creditCardNumber, setCreditCardNumber] = useState('')

  const handleInputChange = useCallback((e: { target: { value: string } }) => {
    const inputVal = e.target.value.replace(/ /g, '')
    let inputNumbersOnly = inputVal.replace(/\D/g, '')

    if (inputNumbersOnly.length > 16) {
      inputNumbersOnly = inputNumbersOnly.substr(0, 19)
    }

    const splits = inputNumbersOnly.match(/.{1,4}/g)

    let spacedNumber = ''
    if (splits) {
      spacedNumber = splits.join('  ')
    }

    setCreditCardNumber(spacedNumber)
  }, [])

  useEffect(() => {
    onChangeInput(creditCardNumber.split(' ').join(''))
  }, [creditCardNumber])

  const renderIcon = () => {
    switch (cardType) {
      case 'Visa':
        return <Icon name={IconNames.visaCard} />
      case 'MasterCard':
        return <Icon name={IconNames.masterCard} />
      case 'American Express':
        return <Icon name={IconNames.aeCard} />
      default:
        return null
    }
  }

  return (
    <InputCreditCardSC errorMessage={errorMessage!}>
      <InputCardBox
        type='text'
        name='creditCardNumber'
        value={creditCardNumber}
        onChange={handleInputChange}
        inputMode={'numeric'}
      />
      {renderIcon()}
    </InputCreditCardSC>
  )
}
